import * as React from "react";
import FormControlContext from "./FormControlContext.es.js";
function useFormControl() {
  return React.useContext(FormControlContext);
}
export {
  useFormControl as default
};
//# sourceMappingURL=useFormControl.es.js.map
